var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row page-header"},[_c('div',{staticClass:"col"},[_c('h4',{staticClass:"header-title"},[_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle)?_c('h5',{staticClass:"header-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }